<div class="app" [ngClass]="{ 'no-header': !headerIsVisible }">
  <aryel-toasts-container></aryel-toasts-container>
  <ui-view></ui-view>
</div>
